<template>
    <b-card
            :title="title"
            img-alt="Image"
            img-top
            tag="article"
            class="mb-2 shadow p-3 mb-5 rounded-lg cursor">
        <b-card-text>
        </b-card-text>
    </b-card>
</template>

<script>
    export default {
        name: "SolutionCardEmpty",
        props: ["title"],
        methods: {
        }
    }
</script>

<style lang="scss" scoped>
    .cursor {
        cursor: pointer;
    }

    .card-body {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
    }

    h4 {
        font-size: 2rem;
        color: #707070;
    }

    article:hover {
        h4 {
            font-weight: bold;
        }
    }

</style>
